<div class="desktop-filter-buttons" #filtersContainer>
  <!-- <fal-mobile-filters
    *ngIf="!isDesktopViewport"
    [filtersModel]="filtersModel"
    [defaultSearchDistanceMobile]="defaultSearchDistance"
    [selectedLocation]="selectedLocation"
    [showSpecialtyFilter]="showServicesAvailableFilter"
    [showLocationTypesFilter]="showLocationTypeFilter"
    [isLocationSelected]="isLocationSelected"
    (filtersModelChange)="handleFilterChange($event)"
  ></fal-mobile-filters> -->
  <div>
    <div class="filter-container" *ngIf="!showLandingFilters">
      <cs-filter-dialog
        [filterTitle]="searchRadiusFilterDisplayText"
        class="filter-container radius-dialog"
        [resetActive]="filtersModel.searchRadius !== defaultDisplayRadiusKey"
        (selectionReset)="filtersModel.searchRadius = defaultDisplayRadiusKey"
        (applyFilters)="handleSearchRadiusChange(filtersModel.searchRadius)"
        [showCloseIcon]="showRadiusCloseIcon"
        (contentReset)="clearRadiusFilter(false)"
        *ngIf="isLocationSelected"
      >
        <div class="range-container">
          <div class="range-header">
            Only show providers within
            <div class="range-number">{{ displayRadius }}</div>
            mi of search location
          </div>
          <div class="range-slider-container">
            <input
              tabindex="0"
              type="range"
              role="slider"
              [(ngModel)]="filtersModel.searchRadius"
              [attr.aria-valuetext]="'Distance'+ displayRadius + 'miles'"
              min="0"
              max="100"
              value="filtersModel.searchRadius"
              step="{{(1 / (filterKeys.length - 1)) * 100}}"
            />
            <div
              class="range-slider-fill"
              [ngStyle]="{
              background:
                'linear-gradient(90deg, var(--dhcl-color-secondary) 0%, var(--dhcl-color-secondary) ' +
                filtersModel.searchRadius +
                '%, #e3e1dc ' +
                filtersModel.searchRadius +
                '%)'
            }"
            ></div>
            <div [ngStyle]="{'display': 'flex'}">
              <div
                *ngFor="let key of filterKeys; let i = index"
                [ngStyle]="{'flex': i === filterKeys.length - 2 ? 0 : 1, 'text-align': i === filterKeys.length - 1 ? 'end' : undefined}"
              >
                {{key.value}}
              </div>
            </div>
          </div>
        </div>
      </cs-filter-dialog>

      <cs-filter-dialog
        [filterTitle]="locationTypeFilterDisplayText"
        [resetActive]="filtersModel.selectedLocationTypes.length > 0"
        [showCloseIcon]="filtersModel.selectedLocationTypes.length > 0"
        [isFALLiteUI]="true"
        (selectionReset)="clearLocationTypeFilter()"
        (contentReset)="filterLocationTypes(false)"
        (applyFilters)="filterLocationTypes(true)"
        class="filter-container"
        (showDialogClick)="initializeLocationTypeDialog()"
        *ngIf="showLocationTypeFilter"
      >
        <div class="dialog-page-content specialty-list grid-container">
          <div
            *ngFor="let locationType of filtersModel.availableLocationTypes"
            class="toggle-col-option"
            (click)="toggleLocationType(locationType)"
          >
            <span class="option-checkbox">
              <svg class="unchecked" *ngIf="!checkLocationType(locationType)" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <rect rx="2.5" width="19" height="19" x="0.5" y="0.5" />
              </svg>
              <svg class="checked" *ngIf="checkLocationType(locationType)" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <rect rx="3" />
                <path d="M10.0001 15L4.16675 9.16663L5.83341 7.49996L10.0001 11.6666L20.0001 1.66663V4.99996L10.0001 15Z" />
              </svg>
            </span>
            {{ locationType.name }}&nbsp;<span class="option-count" *ngIf="locationType.count">({{ locationType.count }})</span>
          </div>
        </div>
      </cs-filter-dialog>

      <cs-filter-dialog
        [filterTitle]="servicesAvailableFilterDisplayText"
        [resetActive]="filtersModel.selectedSpecialties.length > 0"
        [showCloseIcon]="filtersModel.selectedSpecialties.length > 0"
        [isFALLiteUI]="true"
        (selectionReset)="clearSpecialtyFilter()"
        (contentReset)="handleFilterSpecialties(false)"
        (applyFilters)="handleFilterSpecialties(true)"
        class="filter-container"
        (showDialogClick)="initializeSpecialtyDialog()"
        *ngIf="showServicesAvailableFilter"
      >
        <div class="dialog-page-content specialty-list grid-container">
          <div *ngFor="let specialty of filtersModel.availableSpecialties" class="toggle-col-option" (click)="toggleSpecialty(specialty)">
            <span class="option-checkbox">
              <svg class="unchecked" *ngIf="!checkSpecialty(specialty)" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <rect rx="2.5" width="19" height="19" x="0.5" y="0.5" />
              </svg>
              <svg class="checked" *ngIf="checkSpecialty(specialty)" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <rect rx="3" />
                <path d="M10.0001 15L4.16675 9.16663L5.83341 7.49996L10.0001 11.6666L20.0001 1.66663V4.99996L10.0001 15Z" />
              </svg>
            </span>
            {{ specialty.name }}&nbsp;<span class="option-count" *ngIf="specialty.count">({{ specialty.count }})</span>
          </div>
        </div>
      </cs-filter-dialog>
    </div>
    <div class="filter-container" *ngIf="showLandingFilters">
      <div class="filter-comment"><p class="p2">Or choose from these categories:</p></div>
      <div class="desktop-landing-filters">
        <div *ngIf="this.specialtyLandingFilter.length > 0" style="display: contents">
          <div *ngFor="let item of this.specialtyLandingFilter">
            <div
              class="filter-button"
              role="button"
              (click)="landingFilterClicked(item.label, item.type)"
              tabindex="0"
              (keydown.enter)="landingFilterClicked(item.label, item.type)"
              (keydown.space)="landingFilterClicked(item.label, item.type)"
            >
              {{item.value}}
            </div>
          </div>
        </div>
        <div *ngIf="this.locationTypeLandingFilter.length > 0">
          <div *ngFor="let item of this.locationTypeLandingFilter">
            <div
              class="filter-button"
              role="button"
              (click)="landingFilterClicked(item.label, item.type)"
              tabindex="0"
              (keydown.enter)="landingFilterClicked(item.label, item.type)"
              (keydown.space)="landingFilterClicked(item.label, item.type)"
            >
              {{item.value}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
